const LocationPin = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 17">
    <path
      fill="currentColor"
      d="M13 6.33C13 2.897 10.086 0 6.5 0S0 2.94 0 6.394a6.55 6.55 0 0 0 1.21 3.756l2.645 3.519 2.309 3.154c.18.236.538.236.695 0l2.308-3.133 2.645-3.54A6.906 6.906 0 0 0 13 6.33zm-6.007 4.42c-3.048.3-5.603-2.145-5.312-5.085.224-2.167 2.062-3.927 4.326-4.141 3.048-.3 5.603 2.145 5.312 5.085-.224 2.167-2.062 3.927-4.326 4.141z"
    />
  </svg>
)

export default LocationPin
